import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../ui/Modal";
import Button from "../ui/Button";

const TrendsPopup = ({ open, onClose, onExplore, transformOrigin }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={onClose}
      transformOrigin={transformOrigin}
      header={
        <h2 className="text-2xl font-bold text-black text-center mb-6 font-playfair">
          Emerging trends in caregiving
        </h2>
      }
      footer={
        <div className="flex justify-center pt-6">
          <Button
            title="Explore"
            onClick={() => {
              if (onExplore) {
                onExplore();
              } else {
                onClose();
                navigate("/tabs?tab=trends");
              }
            }}
          />
        </div>
      }
    >
      <div className="space-y-3">
        <p className="text-base font-normal leading-loose text-black mb-4">
          Caregiving is influenced by various factors including social, and
          demographic shifts, reforms in healthcare, and technological
          advancements. To provide holistic support to caregivers and keep up
          with the times, it is important to take note of the trends that
          influence caregiving. In this section, we share some emerging global
          trends around caregiving, with country-specific data wherever
          relevant. This knowledge helps us develop a perspective on these
          trends that guide our work.
        </p>

        <p className="text-base font-normal leading-loose text-black mb-3">
          The topics in this section include:
        </p>

        <ul className="space-y-1 text-base font-normal leading-loose text-black list-disc pl-6 mb-6">
          <li>
            The growing aging population and the decline in the number of
            potential family caregivers (India, Bangladesh, Indonesia, Nepal)
          </li>
          <li>Changing family structures and their impact on caregiving</li>
          <li>Decline in the paid care workforce</li>
          <li>Technology and caregiving</li>
          <li>Person-centered care and caregiver-centered care</li>
        </ul>
      </div>
    </Modal>
  );
};

export default TrendsPopup;
